import { render, staticRenderFns } from "./ManageConfigToken.vue?vue&type=template&id=6aa3e808&scoped=true"
import script from "./ManageConfigToken.vue?vue&type=script&lang=ts"
export * from "./ManageConfigToken.vue?vue&type=script&lang=ts"
import style0 from "./ManageConfigToken.vue?vue&type=style&index=0&id=6aa3e808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3e808",
  null
  
)

export default component.exports